import angular from 'angular'

angular
  .module('pub.drop.waitlist', ['pub.drop.waitlist.service'])
  .controller('DropsWaitlistCtrl', DropsWaitlistCtrl)

/** @ngInject */
function DropsWaitlistCtrl($stateParams, DropsWaitlistService) {
  var vm = this
  vm.items = []
  vm.perPage = 25
  vm.parentId = $stateParams.parentId

  function reloadPagination() {
    vm.totalItems = 0
    vm.oldPage = 0
    vm.currentPage = 25
    vm.first = true
    vm.totalItems = 0
    vm.pagination = {
      current: 1,
    }
  }

  reloadPagination()

  function load(pageNumber) {
    if (pageNumber === 1) {
      vm.pagination.current = 1
    }
    if (!vm.first) {
      vm.currentPage = pageNumber * 25
      vm.oldPage = vm.currentPage - 25
    } else {
      vm.first = false
    }

    DropsWaitlistService.list($stateParams.id, vm.oldPage, 25, 'username-asc').then(
      function (result) {
        if (vm.totalItems === 0) {
          vm.totalItems = result.ct
        }

        vm.items = result.results
      },
    )
  }

  load(1)

  vm.load = function () {
    reloadPagination()
    load(1)
  }

  vm.pageChanged = function (newPage) {
    load(newPage)
    $('html, body').animate({ scrollTop: 0 }, 0)
  }
}
